import { render, staticRenderFns } from "./titleBorder.vue?vue&type=template&id=159eeda3&scoped=true"
import script from "./titleBorder.vue?vue&type=script&lang=js"
export * from "./titleBorder.vue?vue&type=script&lang=js"
import style0 from "./titleBorder.vue?vue&type=style&index=0&id=159eeda3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159eeda3",
  null
  
)

export default component.exports